import { TFunction } from 'react-i18next';
import { NhsNumberPolicyValues, SiteData, SiteSettings } from 'types/sites';
import { getServerTime, isBefore, parseDate } from './dateUtil';
import { SelectOption } from 'types/common';
import {
  SITE_ATTRIBUTE_GUIDELINES_PLACEMENT,
  GUIDELINES_PLACEMENT_ABOVE_SLOTS,
  GUIDELINES_PLACEMENT_BEFORE_BOOKING,
  GuidelinesPlacement,
} from 'configs/siteAndTrustAttributes';

export const isSiteExpired = (site: Pick<SiteData, 'expire_date'>): boolean => {
  return isBefore(parseDate(site.expire_date), getServerTime());
};

export const NHS_NUMBER_MANDATORY: NhsNumberPolicyValues =
  'NHS_NUMBER_MANDATORY';
export const NHS_NUMBER_HIDDEN: NhsNumberPolicyValues = 'NHS_NUMBER_HIDDEN';
export const NHS_NUMBER_OPTIONAL: NhsNumberPolicyValues = 'NHS_NUMBER_OPTIONAL';

export const nhsNumberPolicyOptions = (t: TFunction): SelectOption[] => [
  {
    label: t('nhs-number-policy-mandatory'),
    value: NHS_NUMBER_MANDATORY,
  },
  {
    label: t('nhs-number-policy-optional'),
    value: NHS_NUMBER_OPTIONAL,
  },
  {
    label: t('nhs-number-policy-hidden'),
    value: NHS_NUMBER_HIDDEN,
  },
];

export const shouldRenderNhsNumber = (siteSettings: SiteSettings) => {
  return siteSettings.nhs_number_policy !== NHS_NUMBER_HIDDEN;
};

export const isNhsNumberRequired = (siteSettings: SiteSettings) => {
  return siteSettings.nhs_number_policy === NHS_NUMBER_MANDATORY;
};

export const isPostCodeRequired = (siteSettings: SiteSettings) => {
  return !siteSettings.hide_postcode;
};

export const isGpSurgeryRequired = (siteSettings: SiteSettings) => {
  return !siteSettings.hide_gp_surgery;
};

export const toGuidelinesPlacement = (
  value: string | undefined,
): GuidelinesPlacement => {
  return value === GUIDELINES_PLACEMENT_ABOVE_SLOTS
    ? GUIDELINES_PLACEMENT_ABOVE_SLOTS
    : GUIDELINES_PLACEMENT_BEFORE_BOOKING;
};

export const isGuidelinesAboveSlots = (placement: GuidelinesPlacement) => {
  return placement === GUIDELINES_PLACEMENT_ABOVE_SLOTS;
};

export const addOrReplaceGuidelinesPlacement = (
  site: SiteData,
  placement: GuidelinesPlacement,
): SiteData => {
  return {
    ...site,
    attributes: [
      ...(site.attributes || []).filter(
        ({ key }) => key !== SITE_ATTRIBUTE_GUIDELINES_PLACEMENT,
      ),
      {
        key: SITE_ATTRIBUTE_GUIDELINES_PLACEMENT,
        value_int: 0,
        value_str: placement,
      },
    ],
  };
};
